export const GraphColors = {
  Log: "#50D05D",
  Starcheck: "#266BF0",
  Tokyo: "#E42E30",
  Velox: "#000000",
};
